import { memo } from 'react';
import { Link } from 'react-router-dom';
import { AGE_GROUPS, ageLink, ageArt } from '../data/ageGroups';

export const AgeCard = ({ age, compact = false, tabIndex }) => (
  <Link to={ageLink(age)} aria-label={`Shop toys for ${age.label}`} tabIndex={tabIndex}
    className="group relative block aspect-square rounded-2xl overflow-hidden ring-1 ring-black/5 transition duration-300 hover:shadow-medium hover:-translate-y-0.5"
    style={{ backgroundColor: age.tint }}>
    <img src={ageArt(age)} alt={`Child aged ${age.label.toLowerCase()} playing with a wooden toy`}
      width="200" height="200" loading="lazy" decoding="async"
      className={`absolute left-1/2 -translate-x-1/2 top-0 aspect-square ${compact ? 'h-[80%]' : 'h-[82%]'} transition-transform duration-500 group-hover:scale-[1.06]`} />
    <span className={`absolute inset-x-0 bottom-0 bg-white/90 text-center font-sans font-semibold text-espresso ${compact ? 'text-[11px] py-1.5' : 'text-xs md:text-[13px] py-2'}`}>
      {age.label}
    </span>
  </Link>
);

const ShopByAge = ({ title = 'Shop by Age', as: Heading = 'h2' }) => (
  <section className="py-8 md:py-12" aria-labelledby="shop-by-age-heading">
    <div className="container-custom">
      <Heading id="shop-by-age-heading" className="font-serif text-xl md:text-2xl text-espresso text-center mb-5 md:mb-6">
        {title}
      </Heading>
    </div>
    {/* Auto-scrolling row: the list is rendered twice so the loop is seamless; pauses on hover/focus */}
    <div className="age-marquee group/marquee relative overflow-hidden">
      <div className="pointer-events-none absolute inset-y-0 left-0 w-8 md:w-16 z-10 bg-gradient-to-r from-white to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-8 md:w-16 z-10 bg-gradient-to-l from-white to-transparent" />
      <div className="age-marquee-track flex w-max py-1">
        {[0, 1].map(copy => (
          <ul key={copy} className="flex gap-3 md:gap-4 pr-3 md:pr-4" aria-hidden={copy === 1 || undefined}>
            {AGE_GROUPS.map(age => (
              <li key={age.slug} className="w-32 sm:w-36 md:w-44 flex-shrink-0">
                <AgeCard age={age} tabIndex={copy === 1 ? -1 : undefined} />
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  </section>
);

export default memo(ShopByAge);
